<template>
  <!-- lg: nel piè (una riga sola, alto 60px) possono stare fino a cinque
       bottoni (Vai a, Modifica, Elimina corrente, Elimina corrente e futuri,
       Chiudi). -->
  <b-modal
    :id="id"
    size="lg"
    ok-only
    ok-title="Chiudi"
    ok-variant="-transparent"
    header-bg-variant="lisaweb"
    no-close-on-esc
    no-close-on-backdrop
  >
    <template #modal-header="{ cancel }">
      <div slot="modal-title" class="modal-title">
        <b-icon :icon="taskTypeIcon"></b-icon>
        <span>{{ selectInfo.title }}</span>
      </div>
      <button
        type="button"
        class="close"
        title="Chiudi"
        data-dismiss="modal"
        @click="cancel()"
      >
        <base-icon name="close" width="14" height="14"/>
      </button>
    </template>

    <template #modal-footer="{ cancel }">
      <b-form-group>
        <b-row class="mr-2">
          <b-btn
            v-if="hasRelation"
            class="mr-1"
            @click="
            cancel();
            link();
          "
            :title="'Vai a ' + selectInfo.extendedProps.taskable"
            size="sm"
            variant="lisaweb"
          >{{ visualizzaLabel }}
          </b-btn
          >
          <b-btn
            v-if="isEditable"
            class="mr-1"
            @click="
            cancel();
            changeEvent();
          "
            size="sm"
            variant="lisaweb"
          >Modifica
          </b-btn
          >
          <b-btn
            v-if="isDeletable"
            @click="
            cancel();
            deleteEvent(false);
          "
            size="sm"
            variant="-destroy"
          >
            Elimina
            <template v-if="selectInfo.task_recurrence_id != null">
              corrente
            </template
            >
          </b-btn>
          <!-- Sulla stessa riga degli altri: su una riga a parte finiva fuori
               dal piè della modale, tagliato. -->
          <b-btn
            v-if="isDeletable && selectInfo.task_recurrence_id != null"
            class="ml-1"
            @click="
              cancel();
              deleteEvent(true);
            "
            size="sm"
            variant="-destroy"
          >Elimina corrente e futuri
          </b-btn
          >
          <b-btn @click="cancel()" class="ml-1" size="sm" variant="-transparent"
          >Chiudi
          </b-btn
          >
        </b-row>
      </b-form-group>
    </template>
    <b-card class="mt-3">
      <b-card-text v-if="selectInfo">
        <div v-if="hasTime">
          <strong>Orario</strong>
          <div>
            <ul>
              <li v-if="selectInfo.allDay === false && selectInfo.start">
                inizio:
                {{ `${moment(selectInfo.start).format("HH:mm")}` }}
              </li>
              <li v-if="selectInfo.allDay === false && selectInfo.end">
                fine:
                {{ `${moment(selectInfo.end).format("HH:mm")}` }}
              </li>
              <!-- <li v-if="selectInfo.allDay === true">all-day</li> -->
            </ul>
          </div>
        </div>
        <div v-else-if="isAllDay">
          <strong>Tutto il giorno</strong>
        </div>
        <div
          v-if="
            isAllDay ||
            (hasDate && selectInfo.start && !selectInfo.end) ||
            (selectInfo.start &&
              selectInfo.end &&
              moment(selectInfo.start).format('DD/MM/YYYY') ===
                moment(selectInfo.end).format('DD/MM/YYYY'))
          "
        >
          <strong>Giorno</strong>
          <ul>
            <li v-if="selectInfo.start">
              il:
              {{ `${moment(selectInfo.start).format("DD/MM/YYYY")}` }}
            </li>
          </ul>
        </div>
        <div v-else-if="hasDate && selectInfo.start && selectInfo.end">
          <strong>Giorni</strong>
          <ul>
            <li v-if="selectInfo.start">
              da:
              {{ `${moment(selectInfo.start).format("DD/MM/YYYY")}` }}
            </li>
            <li v-if="selectInfo.end">
              a:
              {{ `${moment(selectInfo.end).format("DD/MM/YYYY")}` }}
            </li>
          </ul>
        </div>
        <div v-if="selectInfo.task_recurrence_id != null">
          <div>
            <strong>Ricorrenza</strong>
          </div>
          <div>
            <div class="my-2">
              {{ getRecurrencyLabel(selectInfo.task_recurrence.type) }}
            </div>
          </div>
          <div>
            <strong>Data fine ricorrenza</strong>
          </div>
          <div>
            <div class="my-2">
              {{
                `${moment(selectInfo.task_recurrence.end_date).format(
                  "DD/MM/YYYY"
                )}`
              }}
            </div>
          </div>
        </div>
        <div v-if="selectInfo.extendedProps">
          <div
            v-for="(value, key, index) in selectInfo.extendedProps"
            :key="index"
          >
            <div
              v-for="(v, k, i) in extendedProp(key, value)"
              :key="i"
              v-html="v"
              :class="{ link: key === 'taskable' && value && k === 'text' }"
              :title="
                key === 'taskable' && value && k === 'text'
                  ? `Vai ${
                      value === 'Anagrafiche'
                        ? 'all\'anagrafica'
                        : value === 'Polizze'
                        ? 'alla polizza'
                        : value === 'Sinistri'
                        ? 'al sinistro'
                        : value === 'Contatti di Agenzia'
                        ? 'al contatto'
                        : value === 'Titoli'
                        ? 'al titolo'
                        : value === 'Registrazione a Foglio Cassa'
                        ? 'alla registrazione a foglio cassa'
                        : value
                    }`
                  : ''
              "
              @click="key === 'taskable' && value && k === 'text' && link()"
            ></div>
          </div>
        </div>
      </b-card-text>
    </b-card>
  </b-modal>
</template>
<script>
import {mapGetters} from "vuex";
import moment from "moment";
import BaseIcon from "@/components/BaseIcon";

moment.locale("it");

export default {
  data() {
    return {
      extendedPropsLabels: {
        description: "Descrizione",
        is_public: "Pubblico",
        users: "Attività condivisa con",
        owner_id: "Creatore",
        owner: "Attività aperta da",
        taskable_id: "ID relazione",
        taskable: "Relazione con",
        status_task: "Stato",
        task_type: "Tipo",
        expired_at: "Scadenza il",
        histories: "Ultimo aggiornamento",
        frequency: "Ricorrenza",
        frequency_end_date: "Fine ricorrenza",
      },
      excludedProps: [
        "owner_id",
        "created_at",
        "updated_at",
        "deleted_at",
        "taskable_id",
        "last_update",
        "link",
      ],
      frequencyOptions: [
        {value: 0, text: "Giornaliera"},
        {value: 7, text: "Settimanale"},
        {value: 1, text: "Mensile"},
        {value: 2, text: "Bimestrale"},
        {value: 3, text: "Trimestrale"},
        {value: 4, text: "Quadrimestrale"},
        {value: 6, text: "Semestrale"},
        {value: 12, text: "Annuale"},
      ],
    };
  },
  components: {
    BaseIcon,
  },
  props: {
    id: {
      type: String,
      default: "eventShowModal",
    },
    // taskType: {
    //   type: Number,
    //   default: 0,
    // },
    selectInfo: null,
  },
  computed: {
    isEditable() {
      if (this?.selectInfo?.extendedProps?.owner?.id === 2) return true;
      return this?.selectInfo?.extendedProps?.owner?.id ==
      this?.$store?.state?.auth?.user?.id ||
      (this?.selectInfo?.extendedProps?.owner?.id !=
        this?.$store?.state?.auth?.user?.id &&
        this?.selectInfo?.task_type?.value === 1)
        ? true
        : false;
    },
    isDeletable() {
      if (this?.selectInfo?.extendedProps?.owner?.id === 2) return true;
      return this?.selectInfo?.extendedProps?.owner?.id ==
      this?.$store?.state?.auth?.user?.id
        ? true
        : false;
    },
    taskType() {
      // console.debug(
      //   "eventShow taskType(): ",
      //   this.selectInfo.task_type ? this.selectInfo.task_type.value : "unset"
      // );
      return this.selectInfo.task_type ? this.selectInfo.task_type.value : "";
    },
    taskTypeIcon() {
      let icon;
      switch (this.taskType) {
        case 0:
          icon = "calendar2-event";
          break;
        case 1:
          icon = "paperclip";
          break;
        case 2:
          icon = "journal-minus";
          break;
        default:
          icon = "question-circle";
      }
      return icon;
    },
    isAllDay() {
      return this.selectInfo.allDay;
    },
    hasTime() {
      // fromCalendar && selectInfo.allDay !== undefined
      return [0].includes(this.taskType) && !this.isAllDay;
    },
    hasDate() {
      // fromCalendar && selectInfo.allDay !== undefined
      return [0].includes(this.taskType);
    },
    hasRelation() {
      return this.selectInfo.extendedProps.taskable_id;
    },
    visualizzaLabel() {
      const taskable = this.selectInfo?.extendedProps?.taskable;
      if (!taskable) return "Visualizza";
      // map each relation type to its count source + singular/plural noun
      const map = {
        Anagrafiche: {
          items: "registries",
          singular: "Anagrafica",
          plural: "Anagrafiche",
        },
        Polizze: {
          items: "insurance_policies",
          singular: "Polizza",
          plural: "Polizze",
        },
        Sinistri: { items: "claims", singular: "Sinistro", plural: "Sinistri" },
        "Contatti di Agenzia": {
          items: "agency_contacts",
          singular: "Contatto di Agenzia",
          plural: "Contatti di Agenzia",
        },
        Titoli: {
          items: "insurance_ancillaries",
          singular: "Titolo",
          plural: "Titoli",
        },
        "Registrazione a Foglio Cassa": {
          items: "book_entries",
          singular: "Registrazione a Foglio Cassa",
          plural: "Registrazioni a Foglio Cassa",
        },
      };
      const entry = map[taskable];
      if (!entry) {
        // fallback: capitalize the raw value
        const capitalized =
          taskable.charAt(0).toUpperCase() + taskable.slice(1).toLowerCase();
        return `Visualizza ${capitalized}`;
      }
      const count = (this.selectInfo[entry.items] || []).length;
      return `Visualizza ${count === 1 ? entry.singular : entry.plural}`;
    },
    fromCalendar() {
      return this.taskType === 0 ? true : false;
    },
    getExtendedPropsLabel() {
      return (prop) => this.extendedPropsLabels[prop] || prop;
    },
    getExtendedPropsValue() {
      return (key, value) => this.getText(key, value);
    },
  },
  // mounted() {
  //   this.$refs['myRelation'].firstChild.addEventListener('click', function(event) {
  //     event.preventDefault();
  //     console.log('clicked: ', event.target);
  //   })
  // },
  methods: {
    moment,
    ...mapGetters("auth", {
      getUsers: "users",
    }),
    getRecurrencyLabel(value) {
      return this.frequencyOptions.find((el) => el.value === value).text;
    },
    // extendedProp(key, value) {
    //   let ret = "";
    //   if (!this.excludedProps.includes(key)) {
    //     if (
    //       value &&
    //       ((Array.isArray(value) && value.length) ||
    //         (!Array.isArray(value) &&
    //           typeof value != "object" &&
    //           (value === 0 || value)) ||
    //         (!Array.isArray(value) &&
    //           typeof value == "object" &&
    //           (value.value === 0 || value.value)))
    //     ) {
    //       ret = `<strong>${this.getExtendedPropsLabel(key)}</strong>
    //       <div class="my-2">${this.getText(key, value)}</div>`;
    //     }
    //   }
    //   return ret;
    // },
    extendedProp(key, value) {
      let ret = {label: "", text: ""};
      if (!this.excludedProps.includes(key)) {
        if (
          value &&
          ((Array.isArray(value) && value.length) ||
            (!Array.isArray(value) &&
              typeof value != "object" &&
              (value === 0 || value)) ||
            (!Array.isArray(value) &&
              typeof value == "object" &&
              (value.value === 0 || value.value)))
        ) {
          ret.label = `<strong>${this.getExtendedPropsLabel(key)}</strong>`;
          ret.text = `<div class="my-2">${this.getText(key, value)}</div>`;
        }
      }
      return ret;
    },
    getText(key, value) {
      let ret = "";
      let data;
      let registriesHtml;
      let policyNumber;
      let claimNumber;
      let agencyContact;
      let formattedTitleCode;
      let bookEntryTitle;
      let user;
      switch (key) {
        case "users":
          data = this.selectInfo.extendedProps[key]
            ? this.getUsers()
              .filter((user) =>
                this.selectInfo.extendedProps[key]
                  .map((el) => el.id)
                  .includes(user.value)
              )
              .map((user) => `<li>${user?.username}</li>`)
            : [];
          ret = `<ul>${data.join("")}</ul>`;
          break;
        case "histories":
          user = this.getUsers().find((u) => u?.value === value?.user_id);
          ret = `${user?.username ?? "-"} | ${
            value?.last_update
              ? moment(value.last_update).format("DD/MM/YYYY HH:mm:ss")
              : "-"
          }`;
          break;
        case "owner":
          ret = `${
            this.getUsers().find((user) => user.value === value.id)?.username ??
            value?.id
          } | ${
            value?.date ? moment(value.date).format("DD/MM/YYYY HH:mm:ss") : "-"
          }`;
          break;
        case "is_public":
        case "status_task":
        case "task_type":
          ret = value.text;
          break;
        case "expired_at":
          ret = moment(value).format("DD/MM/YYYY");
          break;
        case "taskable":
          if (value === "Anagrafiche") {
            registriesHtml = this.selectInfo.registries.map((registry) => {
              return `<li>${registry.title}</li>`;
            });
            ret = `<ul>${registriesHtml.join("")}</ul>`;
            break;
          }

          if (value === "Polizze") {
            policyNumber = this.selectInfo.insurance_policies.map((policy) => {
              return `<li>${policy.number}</li>`;
            });
            ret = `<ul>${policyNumber.join("")}</ul>`;
            break;
          }

          if (value === "Sinistri") {
            claimNumber = this.selectInfo.claims.map((claim) => {
              return `<li>${claim.number}</li>`;
            });
            ret = `<ul>${claimNumber.join("")}</ul>`;
            break;
          }

          if (value === "Contatti di Agenzia") {
            agencyContact = this.selectInfo.agency_contacts.map((contact) => {
              return `<li>${contact.formatted_title}</li>`;
            });
            ret = `<ul>${agencyContact.join("")}</ul>`;
            break;
          }

          if (value === "Titoli") {
            formattedTitleCode = this.selectInfo.insurance_ancillaries.map(
              (title) => {
                return `<li>${title.formatted_title}</li>`;
              }
            );
            ret = `<ul>${formattedTitleCode.join("")}</ul>`;
            break;
          }

          if (value === "Registrazione a Foglio Cassa") {
            bookEntryTitle = this.selectInfo.book_entries.map((bookEntry) => {
              return `<li>${bookEntry.formatted_title}</li>`;
            });
            ret = `<ul>${bookEntryTitle.join("")}</ul>`;
            break;
          }

          ret = value;
          break;
        default:
          ret = value;
      }
      return ret;
    },
    changeEvent() {
      this.$emit("change");
    },
    deleteEvent(condition) {
      this.$emit("delete", this.selectInfo, condition);
    },
    link() {
      this.selectInfo.extendedProps.link();
    },
  },
};
</script>
<style lang="scss" scoped>
:deep(.link) {
  cursor: pointer;
  color: blue;
}
</style>
